import Client from "./client";

const baseUrl = `/api/1/doneOrders`;

function doneOrders() {
  return {
    getList: ({ params }) => {
      const url = baseUrl + `/self/all/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    },
  };
}

export default doneOrders();
